import React from 'react';
import styled from 'styled-components';
import breakpoints from 'utils/breakpoints';
import { Section, Container } from 'components/shared';
import {
  getFieldValue,
  Placeholder,
  RichText,
} from '@sitecore-jss/sitecore-jss-react';
import { Copy } from 'components/components/atoms';

const Title = styled.h3`
  letter-spacing: -0.5px;
  line-height: 2.625rem;

  @media ${breakpoints.md} {
    max-width: 35rem;
  }
`;

const Description = styled.p`
  max-width: 46.25rem;
`;

const WarrantyFormContainer = ({ fields, rendering }) => {
  const title = getFieldValue(fields, 'title');
  const description = getFieldValue(fields, 'description');

  return (
    <Section id='warrantyrequest' tabIndex='-1' className='bg-light-blue'>
      <Container>
        <div className='w-full flex flex-col items-center'>
          <Title className='text-mattamy-blue text-center text-4xl font-trade-gothic-20'>
            {title}
          </Title>

          <Description className='font-graphie text-mattamy-blue text-center font-light mb-30-mattamy'>
            {description}
          </Description>

          <Copy className='leading-relaxed'>
            {'Required fields are marked with *'}
          </Copy>
        </div>

        <Placeholder name='form-wrapper' rendering={rendering} />
      </Container>
    </Section>
  );
};

export default WarrantyFormContainer;
